import React, { useEffect, useState } from "react";
import Background from "../../assets/images/bgim.jpeg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRestaurant, getRestaurantLogo } from "../../state/restaurantState";

const FirstPage = ({ id }) => {
  const dispatch = useDispatch();
  const { restaurant, logo, isLoading, isLogoLoading } = useSelector(state => state.restaurants);
  const [resim1, setResim1] = useState(null);
  
  // URL'den id parametresini al veya prop'tan kullan
  const queryParams = new URLSearchParams(window.location.search);
  const urlId = queryParams.get("id");
  const userCode = id || urlId;

  const url =
    "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/" +
    userCode +
    "/";

  useEffect(() => {
    if (userCode) {
      dispatch(getRestaurant(userCode));
      dispatch(getRestaurantLogo(userCode));
      
      // Background image için API çağrısı
      fetch(url + "1").then((data) => {
        data.text().then((text) => {
          if (text && text.trim() !== "" && text !== "null") {
            setResim1(text);
          }
        });
      });
    }
  }, [dispatch, userCode, url]);

  const restaurantData = restaurant && restaurant.length > 0 ? restaurant[0] : null;
  
  // Background image'ı belirle: API'den gelen varsa onu, yoksa default'u kullan
  const backgroundImage = resim1 || Background;
  
  return (
    <div className="h-screen relative overflow-hidden w-full">
      <img
        src={backgroundImage}
        alt="img"
        className="object-cover w-full h-full absolute inset-0 z-0"
      />
      
      {/* Firma Adı - Ekranın Tepesinde */}
      {restaurantData && restaurantData.FIRMA && (
        <div className="absolute top-8 left-1/2 transform -translate-x-1/2 text-center">
          <h1 
            className="text-white text-4xl font-bold px-8 py-4 rounded-lg"
            style={{
              textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)',
              WebkitTextStroke: '1px gray'
            }}
          >
            {restaurantData.FIRMA}
          </h1>
          <p 
            className="text-white text-xl mt-2 px-4 py-2 rounded"
            style={{
              textShadow: '1px 1px 3px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)',
              WebkitTextStroke: '0.25px gray'
            }}
          >
            Hoş Geldiniz
          </p>
        </div>
      )}
      
      {/* Orta Kısım - Logo ve Menü */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center space-y-6">
        {/* Firma Logosu */}
        {logo && (
          <img
            src={logo}
            alt="Firma Logosu"
            className="max-w-48 max-h-32 object-cover rounded-md"
          />
        )}
        
        {/* Menü Butonu */}
        <Link
          to="/category"
          className="text-pink-900 bg-slate-100 border-2 border-gray-300/50 shadow-xl rounded-full px-8 py-4 text-2xl text-center relative z-10 hover:bg-slate-200 transition-colors shadow-lg"
        >
          Menü
        </Link>
      </div>
    </div>
  );
};

export default FirstPage;
